import Form from "@/components/Form";
import './style.css'

export default class RequestInfoForm {
    static selector = '.ri-form'

    constructor(block) {
        this.block = block;

        this.formElement = this.block.querySelector(".form");

        this.form = new Form(this.formElement, {
            onSubmitSucceeded: this.handleSubmitSucceeded,
            submitLoadingLabel: 'Sending...',
            submitSuccessLabel: 'Sent',
            resetAfterSubmit: false,
            gainControlOnSubmitSucceeded: false,
        });
    }

    handleSubmitSucceeded = (response) => {
        console.log('Success!', response);
    };
}
